import { IntegrationEventItem } from '@zond/api-interfaces';
import React from 'react';

interface EventItemProps {
  event: IntegrationEventItem;
  icon?: React.ReactNode;
  badge?: React.ReactNode;
  colorClass?: string;
}

export const EventItem: React.FC<EventItemProps> = ({ event, icon, badge, colorClass }) => {
  return (
    <a
      key={event.id}
      href={event.url}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2 p-2 rounded hover:bg-accent transition-colors"
    >
      {icon && <span className={colorClass}>{icon}</span>}
      <span className="text-sm truncate flex-1">{event.title}</span>
      {badge}
      <span className="text-xs text-muted-foreground whitespace-nowrap">
        {new Date(event.createdAt).toLocaleDateString()}
      </span>
    </a>
  );
};
